<template>
  <div v-show="isActive" class="brains-tabs-details--tab" :class="{ 'brains-tabs-details--tab__no-padding' : !padding }"><slot /></div>
</template>

<script>
export default {
  name: 'BrainsTab',
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Boolean,
      default: true
    },
    ordernumber: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      isActive: false
    }
  },
  computed: {},
  mounted() {
    this.isActive = this.selected
  }
}
</script>

<style lang="scss" scoped>
.brains-tabs-details--tab {
  padding: 10px 15px 10px 15px;
}

.brains-tabs-details--tab__no-padding {
  padding: 0;
}
</style>
